import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Magazine extends Page{
    constructor(){
        super({
            id : 'magazine',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}